import React from 'react';

export const Pagination = (props) => {

  const {
    handleClick,
    page,
    lastPage,
  } = props;

  if ((lastPage === 1 && page === 0) || (lastPage === 0 && page === 0)) {
    return null;
  }

  const onNext = () => {
    handleClick((page + 1))
  };

  const onPrevious = () => {
    handleClick((page - 1))
  };

  return (
    <div className="w-full md:flex md:justify-center md:items-center pt-10 px-4">
      <div className="flex justify-center md:justify-center md:space-x-10 space-x-4 text-grey-simple">
        <button
          type="button"
          onClick={onPrevious}
          disabled={(page === 0) ? "disabled" : ""}
          className={`px-4 py-2 border border-gray-300 rounded ${(page === 0) ? "text-grey-light" : ""}`}
        >
          précédent
        </button>
        <button
          type="button"
          onClick={onNext}
          disabled={(page === (lastPage - 1)) ? "disabled" : ""}
          className={`px-4 py-2 border border-gray-300 rounded ${(page === (lastPage - 1)) ? "text-grey-light" : ""}`}
        >
          suivant
        </button>
      </div>
    </div>
  );
};

export default Pagination;
